import { toast } from 'react-toastify';
import errorHandle from '../../../utils/errorHandle';
import { orgAccountEdit } from '../../../api/orgTripAPI';

export const editOrgAccount = (data, setLoading, setModal, setRender, type) => {
    if (data?.about.length > 200) {
        toast.error('About section must not exceed 200 characters');
    } else if (data?.about.length < 20) {
        toast.error('About section should be at least 20 characters');
    } else {
        try {
            setLoading(true);
            orgAccountEdit(data, type).then((res) => {
                if (res.status === 200) {
                    toast.success('Account updated successfully');
                    setModal(false);
                    setRender(true);
                } else {
                    setLoading(false);
                    toast.error('Something went wrong');
                }
            });
        } catch (err) {
            setLoading(false);
            errorHandle();
        } finally {
            setLoading(false);
        }
    }
};
